export default "__VITE_ASSET__C_aggSN2__"